import './App.css';
//import React, { useEffect, useState, Auth, Login, Todos, NotFound } from "react";
import React, { useEffect, useState} from "react";
import Aside from './components/Aside2';
import UnauthenticatedRoute from './components/UnauthenticatedRoute.js'
import AuthenticatedRoute from './components/AuthenticatedRoute.js'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Opportunities from './pages/Opportunities';
import Observations from './pages/Observations';
import Notifications from './pages/Notifications';
import Recommendations from './pages/Recommendations';
import Privacy from './pages/Privacy';
import Cards from './pages/Cards';
import { useGoogleOneTapLogin } from '@react-oauth/google';


//682ff834

const App = () => {
  
  useGoogleOneTapLogin({
    onSuccess: async (response) => {
      document.cookie = `g_csrf_token=`+response.credential+`; Secure; SameSite=Strict; Path=/`;
      // Send the ID token and CSRF token to the server for verification
      const res = await fetch('https://localhost:8000/api/google-login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id_token: response.credential,
          csrf_token: document.cookie.split('; ').find(row => row.startsWith('g_csrf_token')).split('=')[1],
        }),
      });

      const data = await res.json();
      if (data.success) {
        console.log('Login successful:', data.user);
      } else {
        console.error('Login failed:', data.error);
      }
    },
    onError: (error) => {
      console.error('Google login error:', error);
    },
  });


  return (
    <>
    

    <Router>
      <Aside/>
      <Routes>
        <Route path='/' exact element={ <Dashboard/> }/>
        <Route path='/dashboard' element= { <Dashboard/> }/>
        <Route path='/profile' element={ <Profile/> }/>
        <Route path='/opportunities' element={ <Opportunities/> }/>
        <Route path='/observations' element={ <Observations/> }/>
        <Route path='/notifications' element={ <Notifications/> }/>
        <Route path='/recommendations' element={ <Recommendations/> }/>
        <Route path='/cards' element={ <Cards/> }/>
        <Route path='/privacy' element={ <Privacy/> }/>
        <Route path="*" element={<Navigate replace to="/dashboard" />} />
        <Route path="/404" element={<div>Choose the correct path</div>} />
      </Routes>
     </Router>
     
  </> 
  );
}

export default App;